import * as React from 'react'
import {ReaderFooterPanel} from '../../commons/components/footer/ReaderFooterPanel'
import {MainContainerPanel} from '../../commons/components/main/MainContainerPanel'
import {SettingsPanel} from '../../commons/components/settings/SettingsPanel'
import {ReaderLayout} from '../../commons/layouts/reader-layout/ReaderLayout'
import {ARHeaderPanel} from '../components/header/ARHeaderPanel'
import {ArResourcesPanel} from '../components/resources/ArResourcesPanel'

export const ArSkriptenPage = () => {
  const [showSettings, setShowSettings] = React.useState(false)

  const arHeader = <ARHeaderPanel />
  const arFooter = <ReaderFooterPanel />

  return (
    <ReaderLayout header={arHeader} footer={arFooter} enableScrollTop={true}>
      <MainContainerPanel>
        <ArResourcesPanel
          sections={[{id: 'skripten', heading: 'VÖGB-Skripten', filter: (doc) => Boolean(doc.properties.skriptum)}]}
        />
      </MainContainerPanel>
      <SettingsPanel bottomPosition={false} onToggle={() => setShowSettings(!showSettings)} />
    </ReaderLayout>
  )
}
